import { render, staticRenderFns } from "./OnairBox.vue?vue&type=template&id=018ad200&"
import script from "./OnairBox.vue?vue&type=script&lang=js&"
export * from "./OnairBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports